import React from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import { CircularProgress, CircularProgressProps } from '@mui/material';

export interface ButtonLoaderProps extends ButtonProps {
    submitting?: boolean;

    CircularProgressProps?: CircularProgressProps;
}

const ButtonLoader: React.FC<ButtonLoaderProps> = ({ disabled, submitting, CircularProgressProps, children, ...rest }) => (
    <Button
        {...rest}
        disabled={submitting || disabled}
        startIcon={submitting ? null : rest.startIcon}
        endIcon={submitting ? null : rest.endIcon}
    >
        {submitting && <CircularProgress
            size={40}
            style={{ marginRight: 8 }}
            {...CircularProgressProps}
        />}
        {children}
    </Button>
);

export default ButtonLoader;